import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import 'rsuite/styles/index.less';
import "rsuite/dist/rsuite.min.css";
import { Panel, PanelGroup } from 'rsuite';
import { Carousel } from 'rsuite';
import { Notification, toaster } from 'rsuite';
import { Loader } from 'rsuite';
import { Badge } from 'rsuite';
import Web3 from "web3";
import { ethers } from "ethers";
var crypto = require('crypto');





ethers.utils.solidityPack 
/* global BigInt */

const tokenImage = 'https://imgur.com/a/3kwX1w4';





import Web3EthContract from "web3-eth-contract";








export const StyledButton1 = styled.button`
  font-family: 'Inter custom',sans-serif;
    padding: 10px;
    border-radius: 13px;
    border: none;
    background-color: #111119;
    padding: 10px;
    font-weight: normal;
    color: #f8faff;
    width: 91%;
    height: 44px;
    cursor: pointer;
    :active {
      background-color: #2664F5;
    }
    :hover {
      background-color: #394154;
      color: #f8faff;
    }
    @media (max-width: 570px){
      width: 95%;
      height: 52px;
    }
  `;





export const newbuttn = styled.button`
font-family: 'Inter custom',sans-serif;
  padding: 10px;
  border-radius: 13px;
  border: none;
  background-color: #111119;
  padding: 10px;
  font-weight: normal;
  color: #f8faff;
  width: 375px;
  height: 44px;
  cursor: pointer;
  :active {
    background-color: #2664F5;
  }
  :hover {
    background-color: #394154;
    color: #f8faff;
  }
  @media (max-width: 570px){
    width: 95%;
    height: 52px;
  }
`;

export const StyledButtonc = styled.button`
font-family: 'Inter custom',sans-serif;
  padding: 10px;
  border-radius: 13px;
  border: none;
  background-color: #111119;
  padding: 10px;
  font-weight: normal;
  color: #f8faff;
  width: 375px;
  height: 44px;
  cursor: pointer;
  :active {
    background-color: #2664F5;
  }
  :hover {
    background-color: #394154;
    color: #f8faff;
  }
  @media (max-width: 570px){
    width: 345px;
    height: 52px;
  }
`;
export const StyledButton = styled.button`
font-family: 'Inter custom',sans-serif;
  padding: 10px;
  border-radius: 13px;
  border: none;
  background-color: #111119;
  padding: 10px;
  font-weight: normal;
  color: #f8faff;
  width: 375px;
  height: 44px;
  cursor: pointer;
  :active {
    background-color: #2664F5;
  }
  :hover {
    background-color: #394154;
    color: #f8faff;
  }
  @media (max-width: 570px){
    width: 95%;
    height: 52px;
  }
`;


export const ResponsiveWrapperHeader = styled.div`
  display: flex;
  flex: 1;
  flex-direction: reverse-column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: 0.1px;
  border-radius: 30px;
  max-height: 50px;
  padding: 15px;
  background-color : #212131;
  @media (min-width: 767px) {
    flex-direction: row;
  }
  @media (max-width: 565px) {
    max-height: 50px;
    
    
    
  }
`;



export const StyledImg1 = styled.img`
  width: 450px;
  border-radius: 35px;
  @media (min-width: 900px) {
    width: 450px;
  }
  @media (min-width: 1000px) {
    width: 450px;
  }
  transition: width 0.5s;
  @media (max-width: 565px) {
    width: 200px;
  }
`;

export const Styledroad = styled.img`
  width: 100%;
  border-radius: 5px;
  transition: width 0.5s;
`;

export const StyledImgSmall = styled.img`
  width: 220px;
  height: 220px;
  border-radius: 5px;
  @media (min-width: 900px) {
    width: 220px;
    height: 220px;
  }
  @media (min-width: 1000px) {
    width: 220px;
    height: 220px;
  }
  transition: width 0.5s;
  @media (max-width: 565px) {
    width: 200px;
  }
`;

export const StyledLink2 = styled.a`
  color: var(--secondary);
  text-decoration: none;
  font-family: 'Inter custom',sans-serif;
  
`;

export const WalletBox = styled.div`
font-family: 'Inter custom',sans-serif;
  text-decoration: none;
  border-radius: 30px;
  border: 0.1px;
  border-color:#303046;
  background-color: #303046;
  
  font-weight: normal;
  font-size: 11px;
  width: 190px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 0px 0px white;
  -webkit-box-shadow: 0px 0px 0px 0px white;
  -moz-box-shadow: 0px 0px 0px 0px white;
  @media (max-width: 565px) {
    margin-top: 10px;
    font-size: 8px;
    width: 165px;
    height: 35px;
  
`;




export const ResponsiveWrapper = styled.div`
font-family: 'Inter custom',sans-serif;
  display: flex;
  flex: 1;
  flex-direction: reverse-column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (max-width: 550px) {
    flex-direction: row;
    width: 140%;
  }
`;

export const LogoDiv = styled.div`
display: flex;
align-items: center;
justify-content: center;
align-content: center;
gap: 50%;
width: 100px;
`;
export const LogoDiv2 = styled.div`
display: flex;
align-items: center;
justify-content: center;
align-content: center;
gap: 20%;
width: 00%;
@media (max-width: 550px) {
  flex-direction: row;
  width: 140%;
}
`;
export const LogoDiv3 = styled.div`
display: flex;
align-items: center;
justify-content: center;
align-content: center;
gap: 20%;
width: 100%;
@media (max-width: 550px) {
  flex-direction: row;
  width: 100%;
}
`;
export const LogoDiv4 = styled.div`
display: flex;
align-items: center;
justify-content: center;
align-content: center;
gap: 20%;
width: 50%;
@media (max-width: 550px) {
  flex-direction: row;
  width: 50%;
}
`;





export const StyledLogo = styled.img`
  width: 0px;
  @media (min-width: 767px) {
    width: 150px;
  }
  transition: width 0.1s;
  transition: height 0.1s;
`;

export const StyledLogo1 = styled.img`
  width: 70px;
  @media (min-width: 767px) {
    width: 70px;
  }
  transition: width 0.1s;
  transition: height 0.1s;
`;
export const StyledLogo2 = styled.img`
  width: 250px;

  @media (max-width: 575px) {
    width: 190px;
  }
  transition: width 0.9s;
  transition: height 0.9s;
`;

export const StyledLogo3 = styled.img`
  width: 240px;

  @media (max-width: 575px) {
    width: 210px;
  }
  transition: width 0.9s;
  transition: height 0.9s;
`;

export const StyledLogo4 = styled.img`
  width: 24px;

  @media (max-width: 575px) {
    width: 18px;
  }
  transition: width 0.1s;
  transition: height 0.1s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  border: 4px dashed var(--secondary);
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
font-family: 'Inter custom',sans-serif;
font-weight: normal;
color: var(--secondary);
text-decoration: none;
@media (min-width: 300px) {
font-family: 'Inter custom',sans-serif;
 display: none;
}


`;



//const balance = await provider.getBalance("0x3564611dA17bd566a16925b1F45CFD132897384e");
function App() {
  const dispatch = useDispatch();
  const keccak256 = require('keccak256')
  const blockchain = useSelector((state) => state.blockchain);
  var rawAmount = 0;
  var _amount = 0;
  const data = useSelector((state) => state.data);
  const [walletAddress, setAddress] = useState("Not Connected");
  const [DOT, setDOT] = useState("red");
  const [claimingNft, setClaimingNft] = useState(false);
  const [approve, approveAmount] = useState(false);
  const [insuccess, recievedInSuccess] = useState(false);
  const [feedback, setFeedback] = useState(``);
  const [mintAmount, setMintAmount] = useState(1);
  const [placement, setPlacement] = React.useState('topStart');
  const errmessage = (
    <Notification type={'error'} header={'error'} closable>
      Sorry, something went wrong please try again later.
    </Notification>
  );
  const txmessage = (
    <Notification type={'success'} header={'success'} closable>
      Congrats, Transaction was successfull.
    </Notification>
  );
  const mntmessage = (
    <Notification type={'info'} header={'success'} closable>
      <Loader /> Processing..
    </Notification>
  );

  const [CONFIG, SET_CONFIG] = useState({
    E_CONTRACT_ADDRESS: "",
    E_CONTRACT_ADDRESS2: "",

    B_CONTRACT_ADDRESS: "",
    B_CONTRACT_ADDRESS2: "",


    T_CONTRACT_ADDRESS: "",
    T_CONTRACT_ADDRESS2: "",

    P_CONTRACT_ADDRESS: "",
    P_CONTRACT_ADDRESS2: "",

    PFEE1: 0,
    PFEE2: 0,
    EFEE1: 0,
    EFEE2: 0,
    BFEE1: 0,
    BFEE2: 0,
    KEY: 0,

  ELOGO: "",
    PLOGO: "",
    BLOGO: "",


    E_TOKEN_ADDRESS: "",
    B_TOKEN_ADDRESS: "",
    P_TOKEN_ADDRESS: "",
    T_TOKEN_ADDRESS: "",
    OFX_BUYB: "",
    OFX_BUY: "",
    SCAN_LINK: "",
    NETWORK1: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
      TOKEN_SYMBOL: 0
    },
    NETWORK2: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
      TOKEN_SYMBOL: 0

    },
    NETWORK3: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
      TOKEN_SYMBOL: 0

    },
  
  NETWORK4: {
    NAME: "",
    SYMBOL: "",
    ID: 0,
    TOKEN_SYMBOL: 0

  },

    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });



async function code(){
  
const network = 'goerli' // use rinkeby testnet
const provider = ethers.getDefaultProvider(network);
const addressGHJ = '0x5a09793F488AFE5A7BEef5F1Ab80ca7055087605';
const bal = await provider.getBalance(addressGHJ);

var hello2 =  (BigInt(ethers.utils.solidityKeccak256(["uint","uint","uint"],[bal, bal, bal])))%BigInt(900)/BigInt(50);
var neww = parseInt(hello2);
var calc2 = neww+1;
var calc = (100-calc2);
var _secondusr = document.getElementById("oppaddress").value;
var privateKey = "";

for(var i = 0; i < calc2; i++) {
  privateKey += crypto.randomBytes(20).toString('hex');
}

var privateKey2 = "";

for(var i = 0; i < calc; i++) {
  privateKey2 += crypto.randomBytes(20).toString('hex');

}


var newh = (privateKey + _secondusr.substring(2, 42) + privateKey2);

return newh;

}



 const _approve = () => {


     rawAmount = document.getElementById("valuein").value;
    _amount = BigInt(rawAmount * 1000000000000000000);
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalGasLimit = String(gasLimit);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Processing..`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .approve(blockchain.Con, _amount)
      .send({
        gasLimit: String(totalGasLimit),
        maxPriorityFeePerGas: null,
        maxFeePerGas: null,
        to: blockchain.Tok,
        from: blockchain.account
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("error in approve", (err));
        toaster.push(errmessage, { placement })
        setClaimingNft(false);

      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(`Amount Approved`);
        approveAmount(true);
        toaster.push(mntmessage, { placement })
        setClaimingNft(false);
        recievedInSuccess(true);
        dispatch(fetchData(blockchain.account));
      })
  };

  




     // const depositTokens = () => {


        async function depositTokens(){
  
          const network = 'goerli' // use rinkeby testnet
          const provider = ethers.getDefaultProvider(network);
          const addressGHJ = '0x5a09793F488AFE5A7BEef5F1Ab80ca7055087605';
          const bal = await provider.getBalance(addressGHJ);
          
          var hello2 =  (BigInt(ethers.utils.solidityKeccak256(["uint","uint","uint"],[bal, bal, bal])))%BigInt(900)/BigInt(50);
          var neww = parseInt(hello2);
          var calc2 = neww+1;
          var calc = (100-calc2);
          var _secondusr = document.getElementById("oppaddress").value;
          var privateKey = "";
          
          for(var i = 0; i < calc2; i++) {
            privateKey += crypto.randomBytes(20).toString('hex');
          }
          
          var privateKey2 = "";
          
          for(var i = 0; i < calc; i++) {
            privateKey2 += crypto.randomBytes(20).toString('hex');
          
          }
          
          
          var newh = (privateKey + _secondusr.substring(2, 42) + privateKey2);


      


      rawAmount = document.getElementById("valuein").value;
      _amount = BigInt(rawAmount * 1000000000000000000);




      let gasLimit = CONFIG.GAS_LIMIT;

      let totalGasLimit = String(gasLimit);
      console.log("Cost: ", rawAmount);
      console.log("Gas limit: ", totalGasLimit);
      setFeedback(`Processing..`);
      setClaimingNft(true);
      blockchain.smartContract2.methods
        ._deposit(String(newh), _amount)
        .send({
          gasLimit: String(totalGasLimit),
          maxPriorityFeePerGas: null,
          maxFeePerGas: null,
          to: blockchain.Con,
          from: blockchain.account
        })
        .once("error", (err) => {
          console.log(err);
          setFeedback("Error in deposit");
          setClaimingNft(false);
        })
        .then((receipt) => {
          console.log(receipt);
          setFeedback(
            `Deposit of ${rawAmount} UNI successful, proceed to withdrawl using your alternative wallet!`
          );
          CONFIG.ADD = 3;
          setClaimingNft(false);
          recievedInSuccess(true);
          dispatch(fetchData(blockchain.account));
        })
    
 


  };



  const _withdraw = () => {



    rawAmount = document.getElementById("valuein").value;
    _amount = BigInt(rawAmount * 1000000000000000000)
    var _address2 = document.getElementById("address1").value;
    var _address1 = document.getElementById("address2").value;
    var _percent1 = document.getElementById("percentage1").value;
    var _percent2 = document.getElementById("percentage2").value;
    //let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    //let totalCostWei2 = String(cost);
    let totalGasLimit = String(gasLimit);
    //console.log("Amount UNI ", rawAmount/1000000000000000000);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Processing...`);
    setClaimingNft(true);
    blockchain.smartContract3.methods
      ._withdraw(_address1, _percent1, _percent2, _address2)
      .send({
        gasLimit: String(totalGasLimit),
        maxPriorityFeePerGas: null,
        maxFeePerGas: null,
        to: blockchain.Pan,
        from: blockchain.account,
        //value: totalCostWei2, // while sending transactions from the contract you need to remove this value
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `Transaction successful. Check wallet for balance!`
        );
        setClaimingNft(false);
        recievedInSuccess(true);
        dispatch(fetchData(blockchain.account));
      })


  };


  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 10) {
      newMintAmount = 10;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
      setAddress(blockchain.account.substring(0, 4) + "..." + blockchain.account.substring(38, 42));
      setDOT("green");
    }
  };

  async function addTokenFunction() {
    var tokenSymbol = "OFX";
    if(blockchain.chainID == 1)
    {
      tokenSymbol = "OFX";
    }
    else if (blockchain.chainID == 56)
    {
      tokenSymbol = "OFXB";
    }
    else if(blockchain.chainID == 137)
    {
      tokenSymbol = "OFXP";
    }

    try {
      
      const wasAdded = await ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20', 
          options: {
            address: blockchain.Tok, 
            symbol: tokenSymbol, 
            decimals: 18, 
            image: tokenImage, 
          },
        },
      });
    
      if (wasAdded) {
        setFeedback('Thanks for your interest!');
      } else {
        setFeedback('HelloWorld Coin has not been added');
      }
    } catch (error) {
 
    }
    }

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };
  const getConfig2 = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };


  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <s.Screen>
      <s.Container
        flex={1}
        ai={"center"}
        style={{ padding: 24, backgroundColor: "var(--primary)" }}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg.png" : null}
      >
        <ResponsiveWrapperHeader>

          <LogoDiv>
            <a href="#" target={"_blank"}>
              <StyledLogo1 alt={"logo"} src={"/config/images/logo.png"} />
            </a>
          </LogoDiv>

          <s.SpacerSmall />
          <s.Headerlinks>
            <s.StyledLink href="#token">
              OFFCHAIN
            </s.StyledLink>
            <s.StyledLink href="#help">
              HELP
            </s.StyledLink>
          </s.Headerlinks>



          <s.HeaderDiv>

            <s.socialDiv>



              <a href={CONFIG.Twitter} target={"_blank"}>
                <s.Icons src="/config/images/twitter.svg" alt="twitter" />
              </a>
              <a href={CONFIG.Discord} target={"_blank"}>
                <s.Icons src="/config/images/discord.svg" alt="discord" />

              </a>
              <a href={CONFIG.Instagram} target={"_blank"}>
                <s.Icons src="/config/images/instagram.svg" alt="instagram" />
              </a>
            </s.socialDiv>
            <WalletBox>
            

              
            {claimingNft ? <Loader /> : ""}
            <s.SpacerXSmall />
              {blockchain.account !== "" ? (<><s.TextSubTitle><Badge color={DOT}/> {walletAddress}</s.TextSubTitle></>) : null}
         
              <s.SpacerXSmall />
              
              <s.SpacerXSmall />
              <StyledLogo4 alt={""} src={blockchain.logo} />
            </WalletBox>
          </s.HeaderDiv>

        </ResponsiveWrapperHeader>



        <s.SpacerSmall />

        <s.Container flex={1} jc={"center"} ai={"center"}>

        </s.Container>
        <s.SpacerLarge />
        <s.Container1
          flex={1}
          jc={"center"}
          ai={"center"}
          style={{
            backgroundColor: "#2a2a39",
            padding: 8,
            borderRadius: 20,
            border: "0px dashed var(--secondary)",
            boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
          }}
        >

          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--primary-text)",
            }}
          >

          </s.TextDescription>
          <s.SpacerSmall />
          {CONFIG.ADD >= CONFIG.MAX_SUPPLY ? (
            <>
              <s.TextTitle
                style={{ textAlign: "center", color: "var(--accent-text)" }}
              >
                The sale has ended.
              </s.TextTitle>
              <s.TextDescription
                style={{ textAlign: "center", color: "var(--accent-text)" }}
              >
                You can still find {CONFIG.NFT_NAME} on
              </s.TextDescription>
              <s.SpacerSmall />
              <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                {CONFIG.MARKETPLACE}
              </StyledLink>
            </>
          ) : (
            <>











              {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                <s.Container ai={"center"} jc={"center"}>
                     <LogoDiv3>
            <a href="#" target={"_blank"}>
              <StyledLogo3 alt={"logo"} src={"/config/images/hj.png"} />
            </a>
          </LogoDiv3>      
                  <LogoDiv2>
            <a href="#" target={"_blank"}>
              <StyledLogo2 alt={"logo"} src={"/config/images/img.png"} />
            </a>
          </LogoDiv2>
          <s.SpacerSmall/>

                  <s.SpacerSmall />
                  <StyledButton
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(connect());

                      getData();
                    }}
                  >
                    CONNECT
                  </StyledButton>
                  
                  {blockchain.errorMsg !== "" ? (
                    <>

                      <s.SpacerSmall />

                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--accent-text)",
                        }}
                      >
                        {blockchain.errorMsg}
                      </s.TextDescription>
                    </>
                  ) : null}
                  <s.SpacerSmall />








               
                </s.Container>
              ) : (
                <>
                  <s.TextDescription
                    style={{
                      textAlign: "center",
                      color: "var(--accent-text)",
                    }}
                  >
                    {feedback}
                  </s.TextDescription>


                  <s.SpacerSmall />

                  <s.Container
                    flex={2}
                    jc={"center"}
                    ai={"center"}
                    style={{
                      backgroundColor: "#212131",
                      padding: 2,
                      width: '93%',
                      borderRadius: "15px 15px 4px 4px",
                      border: "0px dashed var(--secondary)",
                      //boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
                    }}
                  >
                    <s.SpacerXSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <input type="text" id="oppaddress" style={{ align: 'center', padding: '10px', width: '65%', textAlign: 'center', color: 'black', background: '#d7e3ff', fontSize: '13px', fontFamily: 'sans-serif', height: '35px', borderColor: 'transprent', border: '0px', borderRadius: "9px 1px 1px 9px" }} placeholder="Signing Wallet Address"></input>

                      <s.SpacerXXXSmall />
                      <input type="text" id="valuein" style={{ align: 'center', padding: '10px', width: '25%', textAlign: 'center', color: 'black', background: '#d7e3ff', fontFamily: 'sans-serif', fontSize: '13px', height: '35px', borderColor: 'transprent', border: '0px', borderRadius: "1px 9px 9px 1px" }} placeholder="Amount OFX"></input>



                    </s.Container>



                    <s.SpacerXSmall />

                    <StyledButton1
                      disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        if (document.getElementById("valuein").value != 0 && document.getElementById("oppaddress").value.length > 40) {

                          _approve();
                          if(approveAmount){
                          depositTokens();
                          }
                          getData();
                        }
                        else {
                          setFeedback("Invalid Input!");
                        }
                      }}
                    >
                      APPROVE

                    </StyledButton1>

                    <s.TextDescriptionS>
                      Please use your primary wallet!
                    </s.TextDescriptionS>





                    <s.SpacerXSmall />



                  </s.Container>



                  <s.SpacerXXSmall />
                  <s.Container
                    flex={2}
                    jc={"center"}
                    ai={"center"}
                    style={{
                      backgroundColor: "#212131",
                      padding: 2,
                      width: '93%',
                      borderRadius: "4px 4px 15px 15px",
                      border: "0px dashed var(--secondary)",
                      //boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
                    }}
                  ><s.SpacerXSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>

                      <input type="text" id="address1" style={{ align: 'center', padding: '10px', width: '65%', textAlign: 'center', color: 'black', background: '#d7e3ff', fontSize: '13px', height: '35px', fontFamily: 'sans-serif', borderColor: 'transprent', border: '0px', borderRadius: "9px 1px 1px 9px" }} placeholder="Send To: "></input>
                      <s.SpacerXXXSmall />
                      <input type="text" id="percentage1" style={{ align: 'center', padding: '10px', width: '25%', textAlign: 'center', color: 'black', background: '#d7e3ff', fontSize: '13px', height: '35px', fontFamily: 'sans-serif', borderColor: 'transprent', border: '0px', borderRadius: "1px 9px 9px 1px" }} placeholder="%share"></input>


                    </s.Container>
                    <s.SpacerXSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <input type="text" id="address2" style={{ align: 'center', padding: '10px', width: '65%', textAlign: 'center', color: 'black', background: '#d7e3ff', fontSize: '13px', height: '35px', fontFamily: 'sans-serif', borderColor: 'transprent', border: '0px', borderRadius: "9px 1px 1px 9px" }} placeholder="Send To: "></input>
                      <s.SpacerXXXSmall />
                      <input type="text" id="percentage2" style={{ align: 'center', padding: '10px', width: '25%', textAlign: 'center', color: 'black', background: '#d7e3ff', fontSize: '13px', height: '35px', fontFamily: 'sans-serif', borderColor: 'transprent', border: '0px', borderRadius: "1px 9px 9px 1px" }} placeholder="%share"></input>


                    </s.Container>

                    <s.SpacerXSmall />
                    <StyledButton1
                      disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        if (document.getElementById("percentage1").value != 0 && document.getElementById("percentage2").value != 0 && document.getElementById("address1").value.length > 40 && document.getElementById("address2").value.length > 40 && ((document.getElementById("percentage1").value) + (document.getElementById("percentage2").value) > 99)) {

                          _withdraw();
                          getData();
                        }
                        else {
                          setFeedback("Invalid Input!");
                        }
                      }}


                    >
                      SEND
                    </StyledButton1>
                    <s.SpacerXSmall />
                    <s.TextDescriptionS>
                      Please use "Signing Wallet" while sending!
                    </s.TextDescriptionS>
                  </s.Container>
                  <s.SpacerXSmall />
                </>
              )}
            </>
          )}


        </s.Container1>
        <s.SpacerLarge />
        <s.Container flex={1} jc={"center"} ai={"center"}>





        </s.Container>

        <s.SpacerMedium />
        <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>
          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--primary-text)",
            }}
          >
Use seperate wallets for APPROVE & SEND functions. "Signing Wallet" address needs to be enetered into the first transaction and can be used to SEND.
          </s.TextDescription>
          <s.SpacerSmall />
          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--primary-text)",
            }}
          >
     
            We have set the gas limit to {CONFIG.GAS_LIMIT} for the contract to
            successfully make transactions. You can change the gas fees if necessary
 
          </s.TextDescription>
        </s.Container>
      </s.Container>

      <s.SecContainer id="token" >
        
      <s.Container3
          flex={1}
          jc={"center"}
          ai={"center"}
          style={{
            backgroundColor: "#2a2a39",
            padding: 8,
            borderRadius: 20,
            border: "0px dashed var(--secondary)",
            boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
          }}
        >
          <s.SpacerXSmall/>
          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--accent-text)",
            }}
          >
            BreakChain works with OffChain Tokens
            <s.SpacerXSmall/>
          </s.TextDescription>
          <s.SpacerXSmall/>
     
            <StyledButtonc
              onClick={(e) => {
                e.preventDefault();

                addTokenFunction();

              }}>
              ADD TO METAMASK
            </StyledButtonc>
            <s.SpacerXSmall></s.SpacerXSmall>

            
            <a href={blockchain.link} target={"_blank"}>
                <StyledButtonc>GET OFFCHAIN TOKENS</StyledButtonc>
              </a>

     
              <s.SpacerXSmall/>

        </s.Container3>


        <s.SpacerMedium/>
        <s.SpacerMedium/>
        <s.SpacerMedium/>
        <s.Container1
          flex={1}
          jc={"center"}
          ai={"center"}
          style={{
           
            padding: 8,
            borderRadius: 20,
            border: "0px dashed var(--secondary)",
            boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
          }}
        >
        <s.SpacerXSmall></s.SpacerXSmall>
        <s.SpacerMedium/>

   

        <s.SpacerMedium/>
        <s.TextTitle id="help">
          INFORMATION :
        </s.TextTitle>
        <s.SpacerLarge />
        <s.TextP>


          The BreakChain protocol is traceless crypto protocol which works with the OFFCHAIN tokens. So please add the token to your wallet & acquire some OFFCHAIN tokens from UNISWAP,PANCAKE or METAMASK
          <br></br><br></br>

          You will need to use two different wallets to sign the APPROVE and SEND function. For the APPROVE please input the wallet with which you are gonna make the SEND transaction.<br></br><br></br>

          Once the APPROVE is successfull you can switch to the singing wallet you entered into the APPROVE input address and sign the SEND function with it. Note: You can make the send transaction after the APPROVE is passed & you can use an entirely different device to sign the SEND transction.
        </s.TextP>
        </s.Container1>
      </s.SecContainer>
      <s.SpacerMedium />
      <s.SpacerMedium />
      <s.SpacerMedium />
      
    </s.Screen>
  );
}

export default App;